"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putPostcodePrice = void 0;
/**
 * Allows you to create a new or completely replace an existing postcode price
 */
var putPostcodePrice = function (instance) {
    return function (id, sku, postcode, body, config) {
        return instance.put("/catalogues/".concat(id, "/postcode-prices/").concat(sku, "/").concat(postcode), body, config);
    };
};
exports.putPostcodePrice = putPostcodePrice;
